<template>
  <div>
    <!-- Bouton de rafraîchissement -->
    <b-row class="justify-content-start">
      <b-col cols="4" lg="2" xl="1" class="mb-5">
        <b-button class="btnFilter"
          @click="displayFilter = !displayFilter">
          <i v-if="displayFilter" class="fa-light fa-minus"></i>
          <i v-else class="fa-light fa-plus"></i>
          {{ $t('filter.fltr') }}
        </b-button>
      </b-col>
      <b-col cols="4" lg="2" xl="1" class="mb-5">
        <b-button
          class="btnFilter"
          :disabled="activateSpinner"
          @click="onRefresh()">
          <i class="fa-light fa-rotate-right fs-14px"></i>
        {{ $t('common.rfrsh') }}
        </b-button>
      </b-col>
    </b-row>
    <b-row class="justify-content-start align-items-center" :class="{'filter-item-section':true, 'd-none': !displayFilter}">
      <!-- Filtre date de début -->
      <b-col sm="6" lg="3" cols="12" class="filter-item mb-5">
        <datetime-picker-custom format="DD/MM/YYYY H:i:s"
          id="filter-datebegin"
          :class="{'filter-item-input': true, 'filter-item-input-complete': dateBegin}"
          :inputLabel="$t('common.date_start_label')"
          customInputParentClass="filter-item-content"
          customInputClass="w-100"
          :maxLength="19"
          :placeholderValue="$t('common.datetime_picker_empty_date')"
          inputIcon="fa-solid fa-calendar"
          v-model="dateBegin">
        </datetime-picker-custom>
      </b-col>
      <!-- Filtre date de fin -->
      <b-col sm="6" lg="3" cols="12" class="filter-item mb-5">
        <datetime-picker-custom format="DD/MM/YYYY H:i:s"
          id="filter-dateend"
          :class="{'filter-item-input': true, 'filter-item-input-complete': dateEnd}"
          :inputLabel="$t('common.date_end_label')"
          customInputParentClass="filter-item-content"
          customInputClass="w-100"
          :maxLength="19"
          :placeholderValue="$t('common.datetime_picker_empty_date')"
          inputIcon="fa-solid fa-calendar"
          v-model="dateEnd">
        </datetime-picker-custom>
      </b-col>
      <!-- Filtre FileName -->
      <b-col sm="6" lg="3" cols="12" class="filter-item mb-5">
        <label class="filter-item-title" for="filter-file-name">{{ $t('common.entity_account.file_name') }}</label>
        <span class="filter-item-content">
          <input v-model.trim="FileName"
            id="filter-file-name"
            type="text"
            :class="{'filter-item-input': true, 'filter-item-input-complete': FileName}"
            :placeholder="$t('common.entity_account.file_name')"
            style="width: 100%">
        </span>
      </b-col>
      <!-- Filtre FileReference -->
      <b-col sm="6" lg="3" cols="12" class="filter-item mb-5">
        <label class="filter-item-title" for="filter-file-reference">{{ $t('common.entity_account.file_reference') }}</label>
        <span class="filter-item-content">
          <input v-model.trim="FileReference"
            id="filter-file-reference"
            type="text"
            :class="{'filter-item-input': true, 'filter-item-input-complete': FileReference}"
            :placeholder="$t('common.entity_account.file_reference')"
            style="width: 100%">
        </span>
      </b-col>
      <!-- Filtre Statut -->
      <b-col sm="6" lg="3" cols="12" class="filter-item mb-5">
        <label class="filter-item-title" for="filter-status">{{ $t('common.entity_account.file_status') }}</label>
        <select class="form-control mw-100" v-model="Status" id="filter-status">
          <option value="" disabled selected>{{ $t('common.entity_account.select_file_status') }}</option>
          <option
            v-for="status in statusOptions"
            :key="status.id"
            :value="status.id">
            {{ status.text }}
          </option>
        </select>
      </b-col>
      <!-- Filtre Type de synchronisation -->
      <b-col sm="6" lg="3" cols="12" class="filter-item mb-5">
        <label class="filter-item-title" for="filter-status">{{ $t('common.entity_account.synchro_type') }}</label>
        <select class="form-control mw-100" v-model="SynchroType" id="filter-type">
          <option value="" disabled selected>{{ $t('common.entity_account.select_synchro_type') }}</option>
          <option
            v-for="type in typeOptions"
            :key="type.id"
            :value="type.id">
            {{ type.text }}
          </option>
        </select>
      </b-col>
    </b-row>

    <b-row class="justify-content-end" v-if="displayFilter">
      <!-- Boutons Effacer et Appliquer -->
      <b-col sm="4" lg="2" cols="12" class="mt-4 mb-5">
        <b-button class="mr-3" size="sm"
                  @click="clearFilterFields" :disabled="activateSpinner">
          {{ $t('filter.clr_fltr_field') }}
        </b-button>
      </b-col>
      <b-col sm="4" lg="2" cols="12" class="mt-4 mb-5">
        <b-button class="btn" size="sm"
                  @click="onRefresh">
          {{ $t('common.srch') }}
        </b-button>
      </b-col>
    </b-row>
    <b-row class="mb-5">
      <b-col cols="12">
        <div style="overflow:auto">
          <spinner v-if="activateSpinner"></spinner>
          <b-table v-else-if="listItemsEntityAccountFile.length > 0"
            :items="listItemsEntityAccountFile"
            :fields="fields"
            class="table-striped"
            hover
            :selectable="listItemsEntityAccountFile.length > 0"
            :empty-text="$t('common.security.no_result')"
            style="margin-bottom:0"
            :sort-by.sync="sortBy"
            :sort-desc.sync="sortDir"
            @head-clicked="sortTable"
            @row-selected="onRowClicked"
            :key="refreshKey">
            <template #cell(DateStartImport)="data">
              <span v-if="data.value !== ''">{{ getDate(data.value) }}</span>
              <span v-else>-</span>
            </template>
            <template #cell(FileName)="data">
              <span v-if="data.value !== ''">{{ data.value }}</span>
              <span v-else>-</span>
            </template>
            <template #cell(FileReference)="data">
              <span v-if="data.value !== ''">{{ data.value }}</span>
              <span v-else>-</span>
            </template>
            <template #cell(Bic)="data">
              <span v-if="data.value !== ''">{{ data.value }}</span>
              <span v-else>-</span>
            </template>
            <template #cell(Status)="data">
              <span v-if="data.value !== ''">{{ $t('common.entity_account.file_status_' + data.value) }}</span>
              <span v-else>-</span>
            </template>
            <template #cell(SynchroType)="data">
              <span v-if="data.value !== ''">{{ $t('common.entity_account.synchro_type_' + data.value) }}</span>
              <span v-else>-</span>
            </template>
            <template #cell(ImportResult)="data">
              <span v-if="data.value !== ''">{{ $t('common.entity_account.import_result_' + data.value) }}</span>
              <span v-else>-</span>
            </template>
            <template #cell(NbOK)="data">
              <span v-if="data.value !== ''">{{ data.value }}</span>
              <span v-else>-</span>
            </template>
            <template #cell(NbKO)="data">
              <span v-if="data.value !== ''">{{ data.value }}</span>
              <span v-else>-</span>
            </template>
          </b-table>
          <div v-else class="d-flex justify-content-center">
            <span class="noResult">
              {{ $t('common.no_result') }}
            </span>
          </div>
        </div>
      </b-col>
    </b-row>
    <b-row class="mt-5">
      <b-col>
        <cm-pagination
          :maxResultsByPage="paginationObject.maxResults"
          :firstIndex="paginationObject.firstIndex"
          :nbResultsTotal="paginationObject.nbResultsTotal"
          :refreshEvent="paginationObject.refresh">
        </cm-pagination>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import formWriteGroupLabelInput from "@/components/common/formWriteGroupLabelInput.vue"
import Pagination from '@/components/common/pagination.vue'
import moment from 'moment'
import PageOutline from "@/components/common/PageOutline.vue"
import Spinner from "@/components/common/spinner.vue"
import { errorMessageAlert } from "@/helpers/alert"
import { loadPage } from "@/helpers/routing"
import dateTimePicker from '@/components/common/dateTimePicker.vue'

export default {
  name: "EntityAccountFileList",
  components: {
    'cm-pagination': Pagination,
    'datetime-picker-custom': dateTimePicker,
    "form-write-group-label-input": formWriteGroupLabelInput,
    "page-outline": PageOutline,
    spinner: Spinner
  },
  props: {
    id: {
      type: String,
      default: "-1",
    },
  },
  data() {
    return {
      activateSpinner: false,
      dateBegin: '',
      dateEnd: '',
      displayFilter: false,
      filterConditions: {},
      listItemsEntityAccountFile: [],
      listTitle: "",
      FileName: '',
      FileReference: '',
      pageCounter: 0,
      paginationObject: {},
      refreshKey: false,
      sortBy: '',
      sortDir: false,
      Status: '',
      statusOptions: [1, 2, 3, 4, 5, 6, 7, 8, 9, 20, 21, 22, 91, 92, 93].map(id => ({
        id: id.toString(),
        text: this.$t(`common.entity_account.file_status_${id}`)
      })),
      SynchroType: '',
      typeOptions: [
        { id: "REPLACEFULL", text: this.$t('common.entity_account.synchro_type_REPLACEFULL') },
        { id: "DELTA", text: this.$t('common.entity_account.synchro_type_DELTA') },
        { id: "DELETEDELTA", text: this.$t('common.entity_account.synchro_type_DELETEDELTA') },
        { id: "UNRECOGNIZED", text: this.$t('common.entity_account.synchro_type_UNRECOGNIZED') }
      ]
    }
  },
  created() {
    const queryParams = this.$route.query

    if (queryParams.firstIndex) {
      this.paginationObject['firstIndex'] = queryParams.firstIndex
    } else {
      this.paginationObject['firstIndex'] = 1
    }
    if (queryParams.FileName) {
      this.FileName = queryParams.FileName
    }
    if (queryParams.FileReference) {
      this.FileReference = queryParams.FileReference
    }
    if (queryParams.dateBegin) {
      let decodedDateBegin = decodeURIComponent(queryParams.dateBegin)
      let formattedDateBegin = decodedDateBegin.replace('%2F', '/').replace('%2F', '/').replace('+', ' ').replace('%3A', ':').replace('%3A', ':')
      this.dateBegin = formattedDateBegin
    }
    if (queryParams.dateEnd) {
      let decodedDateEnd = decodeURIComponent(queryParams.dateEnd)
      let formattedDateEnd = decodedDateEnd.replace('%2F', '/').replace('%2F', '/').replace('+', ' ').replace('%3A', ':').replace('%3A', ':')
      this.dateEnd = formattedDateEnd
    }
    if (queryParams.Status) {
      this.Status = queryParams.Status
    }
    if (queryParams.SynchroType) {
      this.SynchroType = queryParams.SynchroType
    }
    if (queryParams.OrderByField) {
      this.filterConditions.OrderByField = queryParams.OrderByField
    }
    if (queryParams.OrderByDirection) {
      this.filterConditions.OrderByDirection = queryParams.OrderByDirection
    }
    if (queryParams.displayFilter) {
      this.displayFilter = queryParams.displayFilter
    }
    if (this.filterConditions) {
      if (this.filterConditions.OrderByField) {
        this.sortBy = this.filterConditions.OrderByField
      }
      if (this.filterConditions.OrderByDirection) {
        this.sortDir = this.filterConditions.OrderByDirection === 'DESC'
      }
    }
    this.listTitle = this.$i18n.t("common.entity_account.entity_account_file")
    this.activateSpinner = true
    this.paginationObject['maxResults'] = 15
    this.paginationObject['nbResultsTotal'] = 0
    let that = this
    this.$bus.$off('refresh-cache-contacts')

    this.paginationObject['refresh'] = 'direct-inbox-filtered'
    this.$bus.$off('direct-inbox-filtered')
    this.$bus.$on('direct-inbox-filtered', index => {
      this.getEntityAccountFile(index)
      that.pageCounter = 0
    })

    this.$f7.initPullToRefresh()
    this.pageCounter = 0
    if (queryParams.firstIndex > 1) {
      this.getEntityAccountFile(this.paginationObject['firstIndex'])
    } else {
      this.getEntityAccountFile()
    }

    if (this.id !== "-1") {
      this.tabName = parseInt(this.id)
    }
  },
  computed: {
    canDelete () {
      return true
    },
    canEdit () {
      return true
    },
    fields () {
      let fields = []
      fields.push({
        key: 'DateStartImport',
        label: this.$t('common.entity_account.date_start_import'),
        class: 'text-center',
        sortable: true
      })
      fields.push({
        key: 'FileName',
        label: this.$t('common.entity_account.file_name'),
        class: 'text-center',
        sortable: true
      })
      fields.push({
        key: 'FileReference',
        label: this.$t('common.entity_account.file_reference'),
        class: 'text-center',
        sortable: true
      })
      fields.push({
        key: 'Bic',
        label: this.$t('common.entity_account.bic'),
        class: 'text-center',
        sortable: true
      })
      fields.push({
        key: 'Status',
        label: this.$t('common.entity_account.file_status'),
        class: 'text-center',
        sortable: true
      })
      fields.push({
        key: 'SynchroType',
        label: this.$t('common.entity_account.synchro_type'),
        class: 'text-center',
        sortable: true
      })
      fields.push({
        key: 'ImportResult',
        label: this.$t('common.entity_account.import_result'),
        class: 'text-center',
        sortable: true
      })
      fields.push({
        key: 'NbOK',
        label: this.$t('common.entity_account.nb_iban_processed'),
        class: 'text-center',
        sortable: false
      })
      fields.push({
        key: 'NbKO',
        label: this.$t('common.entity_account.nb_iban_rejected'),
        class: 'text-center',
        sortable: false
      })
      return fields
    }
  },
  methods: {
    applyFilter(filterConditions = {}) {
      this.filterConditions = filterConditions

      this.pageCounter = 0
      this.paginationObject['firstIndex'] = 1
      this.paginationObject['nbResultsTotal'] = 0

      this.activateSpinner = true

      if (this.filterConditions.OrderByField) {
        this.sortBy = this.filterConditions.OrderByField
      }
      if (this.filterConditions.OrderByDirection) {
        this.sortDir = this.filterConditions.OrderByDirection === 'DESC'
      }

      this.getEntityAccountFile()
    },
    clearFilterFields() {
      this.FileName = ''
      this.FileReference = ''
      this.dateBegin = ''
      this.dateEnd = ''
      this.Status = ''
      this.SynchroType = ''
      // this.applyFilter()
    },
    getEntityAccountFile(index = 1) {
      this.pageCounter = 0
      this.paginationObject['firstIndex'] = index
      this.paginationObject['nbResultsTotal'] = 0
      let that = this
      let params = {
        FileName: this.FileName,
        FileReference: this.FileReference,
        dateBegin: this.dateBegin != '' ? moment(this.dateBegin , 'DD/MM/YYYY HH:mm:ss').utc().format('YYYY-MM-DD HH:mm:ss') : '',
        dateEnd: this.dateEnd != '' ? moment(this.dateEnd , 'DD/MM/YYYY HH:mm:ss').utc().format('YYYY-MM-DD HH:mm:ss') : '',
        // dateBegin: this.dateBegin != '' ? moment(this.dateBegin , 'DD/MM/YYYY HH:mm:ss').format('YYYY-MM-DD HH:mm:ss') : '',
        // dateEnd: this.dateEnd != '' ? moment(this.dateEnd , 'DD/MM/YYYY HH:mm:ss').format('YYYY-MM-DD HH:mm:ss') : '',
        Status: this.Status,
        SynchroType: this.SynchroType,
        maxResults: this.paginationObject.maxResults,
        firstIndex: this.paginationObject.firstIndex
      }

      if (this.filterConditions.OrderByField) {
        params.OrderByField = this.filterConditions.OrderByField
      }
      if (this.filterConditions.OrderByDirection) {
        params.OrderByDirection = this.filterConditions.OrderByDirection
      }
      this.$engine.entityAccount.getEntityAccountFile(params).then((resp) => {
        that.paginationObject.nbResultsTotal = resp.data.nbTotalResults
        that.paginationObject.nbResults = resp.data.EntityAccountFile.length

        let EntityAccountFileList = {}

        EntityAccountFileList = resp.data.EntityAccountFile

        that.updateEntityAccountFile(EntityAccountFileList)

        this.$f7.pullToRefreshDone()
        that.activateSpinner = false
      })
      .catch(error => {
        errorMessageAlert(error, that)
      })
    },
    getDate (date) {
      if (date != ''){
        return moment.utc(date).local().format('DD/MM/YYYY HH:mm:ss.SSS')
      }
      else {
        return '-'
      }
    },
    onRefresh() {
      this.refreshKey = !this.refreshKey
      this.activateSpinner = true
      this.getEntityAccountFile()
    },
    onRowClicked(item) {
      if (item?.[0]?.IdEntityAccountFile) {
          const params = {}

          if (this.FileName !== '') params.FileName = this.FileName
          if (this.FileReference !== '') params.FileReference = this.FileReference
          if (this.dateBegin !== '') {
              params.dateBegin = this.dateBegin
          }
          if (this.dateEnd !== '') {
              params.dateEnd = this.dateEnd
          }
          if (this.Status !== '') params.Status = this.Status
          if (this.SynchroType !== '') params.SynchroType = this.SynchroType
          if (this.paginationObject.maxResults !== '') params.maxResults = this.paginationObject.maxResults
          if (this.paginationObject.firstIndex !== '') params.firstIndex = this.paginationObject.firstIndex

          if (this.filterConditions.OrderByField) {
              params.OrderByField = this.filterConditions.OrderByField
          }
          if (this.filterConditions.OrderByDirection) {
              params.OrderByDirection = this.filterConditions.OrderByDirection
          }

          if (this.displayFilter !== false) params.displayFilter = this.displayFilter

          if (Object.keys(params).length > 0) {
              const queryParams = new URLSearchParams(params).toString()
              loadPage(this, { url: `/entityAccountFile/details/${item[0].IdEntityAccountFile}?${queryParams}` })
          }
      }
    },
    sortTable (key, field, event, isFooter) {
      const sortableFields = [
        'FileName',
        'FileReference',
        'DateStartImport',
        'Status',
        'SynchroType',
        'ImportResult',
        'Bic'
      ]

      if (!sortableFields.includes(key)) {
        return
      }

      let sortDirection = 'ASC'
      if (key === this.sortBy && this.sortDir === false) {
        sortDirection = 'DESC'
      }

      this.filterConditions.OrderByField = key
      this.filterConditions.OrderByDirection = sortDirection

      this.applyFilter(this.filterConditions, this.paginationObject.firstIndex)
    },
    updateEntityAccountFile(EntityAccountFileList) {
      this.listItemsEntityAccountFile = EntityAccountFileList
    }
  }
}
</script>
